import { createSlice } from '@reduxjs/toolkit';
import ApiService from 'services/ApiService';
import axios from 'services/ApiAdaptor';

const getMultipartConfig = () => {
  const token = window.localStorage.getItem('serviceToken');
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  if (token) {
    config.headers['x-access-token'] = token;
  }
  return config;
};

const initialState = {
  lists: {
    items: [],
    totalItems: 0
  },
  currentPage: 0,
  pageSize: 150,
  error: null,
  list: null
};

const slice = createSlice({
  name: 'quantitative',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
      state.currentPage = action.payload.currentPage;
      state.pageSize = action.payload.pageSize;
    },
    getSingleList(state, action) {
      state.list = action.payload;
    },
    createQuantitative(state, action) {
      state.lists.items = [...state.lists.items, action.payload];
      state.lists.totalItems += 1;
    },
    updateQuantitative(state, action) {
      const updatedQuantitative = action.payload;
      state.lists.items = state.lists.items.map((item) => (item.id === updatedQuantitative.id ? updatedQuantitative : item));
    },
    deleteQuantitative(state, action) {
      const quantitativeId = action.payload;
      state.lists.items = state.lists.items.filter((item) => item.id !== quantitativeId);
      state.lists.totalItems -= 1;
    }
  }
});

export const { getLists, getSingleList, createQuantitative, updateQuantitative, deleteQuantitative } = slice.actions;

export default slice.reducer;

export function getQuantitativeList(page, pageSize) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/quantitative/list',
        params: { page, pageSize }
      };
      const response = await ApiService.get(objData);
      // console.log('response', response);
      dispatch(
        getLists({
          items: response.data.items,
          totalItems: response.data.totalItems,
          currentPage: page - 1,
          pageSize: pageSize
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getQuantitativeInsert(NewLists) {
  return async (dispatch) => {
    try {
      const data = new FormData();
      Object.keys(NewLists).forEach((key) => {
        if (key === 'files' && NewLists[key] && NewLists[key][0]) {
          data.append('file', NewLists[key][0]);
        } else if (key === 'quantitativeStandards' && Array.isArray(NewLists[key])) {
          data.append(key, JSON.stringify(NewLists[key]));
        } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
          data.append(key, NewLists[key]);
        }
      });
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/quantitative/quantitativeUpload`, data, getMultipartConfig());
      if (response.status === 200) {
        dispatch(createQuantitative(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getQuantitative(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/quantitative/details', { id });
      dispatch(getLists(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

export function getQuantitativeSingleList(quantitativeId) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/quantitative/list/single', quantitativeId);
      dispatch(getSingleList(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
    }
  };
}

// export function getQuantitativeUpdate(NewLists) {
//   return async (dispatch) => {
//     try {
//       const data = new FormData();
//       Object.keys(NewLists).forEach((key) => {
//         if (key === 'files' && NewLists[key] && NewLists[key][0]) {
//           data.append('file', NewLists[key][0]);
//         } else if (key === 'quantitativeStandards' && Array.isArray(NewLists[key])) {
//           data.append(key, JSON.stringify(NewLists[key]));
//         } else if (NewLists[key] !== null && NewLists[key] !== undefined) {
//           data.append(key, NewLists[key]);
//         }
//       });
//       const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/quantitative/quantitativeUpdate`, data, getMultipartConfig());
//       console.log('response:', response);
//       if (response.status === 200) {
//         dispatch(updateQuantitative(response.data));
//         return { success: true, data: response.data };
//       } else {
//         return { success: false, message: response.message };
//       }
//     } catch (error) {
//       dispatch(slice.actions.hasError(error.toString()));
//       return { success: false, error };
//     }
//   };
// }

export function getQuantitativeUpdate(NewLists) {
  return async (dispatch) => {
    try {
      let response;
      const data = new FormData();
      Object.keys(NewLists).forEach((key) => {
        if (key === 'files' && NewLists[key][0]) {
          data.append('file', NewLists[key][0]);
        } else if (key === 'quantitativeStandards' && Array.isArray(NewLists[key])) {
          data.append(key, JSON.stringify(NewLists[key]));
        } else {
          data.append(key, NewLists[key]);
        }
      });
      response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/quantitative/quantitativeUpdate`, data, getMultipartConfig());
      console.log('response:', response);
      if (response.status === 200) {
        dispatch(updateQuantitative(response.data));
        return { success: true, data: response.data };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      return { success: false, error };
    }
  };
}

export function getQuantitativeDelete(quantitativeId) {
  return async (dispatch) => {
    try {
      const objData = {
        path: '/quantitative/delete',
        data: { id: quantitativeId }
      };
      const response = await ApiService.post(objData);
      if (response.status === 200) {
        dispatch(deleteQuantitative(quantitativeId));
        return response.data;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.toString()));
      throw error;
    }
  };
}
